__turbopack_context__.v({
  "buttonWrapper": "OrderSummary-module__4KtgLq__buttonWrapper",
  "hintText": "OrderSummary-module__4KtgLq__hintText",
  "lineItem": "OrderSummary-module__4KtgLq__lineItem",
  "lineItemLabel": "OrderSummary-module__4KtgLq__lineItemLabel",
  "lineItemPrice": "OrderSummary-module__4KtgLq__lineItemPrice",
  "productTitle": "OrderSummary-module__4KtgLq__productTitle",
  "strikethroughPrice": "OrderSummary-module__4KtgLq__strikethroughPrice",
  "summaryContainer": "OrderSummary-module__4KtgLq__summaryContainer",
  "summaryContent": "OrderSummary-module__4KtgLq__summaryContent",
  "totalContainer": "OrderSummary-module__4KtgLq__totalContainer",
});
